import React, { useEffect, useState } from "react";

import { SearchParams } from "../../atomic_components/types";
import { AppDispatch } from "../../state";
import { useDispatch } from "react-redux";
import { ActiveTab__Action } from "../../state/action-creators";
import { useAppSelector } from "../../state/hooks";
import { useHistory, useParams } from "react-router-dom";
import PurchaseOrdersAdd from "./PurchaseOrdersAdd";
import PurchaseOrdersOpen from "./PurchaseOrdersOpen";
import PurchaseOrdersListingView from "./PurchaseOrdersListingView";

interface RouteParams {
  category: string; // Define the type for the parameter you're expecting
}

function PurchaseOrdersHome() {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const userDetailsFromStore = useAppSelector(
    (state) => state.userdetails_store
  );
  useEffect(() => {
    if (!userDetailsFromStore.authorities.includes("AUTH_ADMIN")) {
      history.push(`/listings/all`);
    }
    dispatch(ActiveTab__Action("vendor-purchase-orders"));
  }, []);

  const { category } = useParams<RouteParams>();
  const [selectedItem, setSelectedItem] = useState(category);
  const handleItemClick = (item: string) => {
    setSelectedItem(item);
    history.push(`/vendor-purchase-orders/${item}`);
  };

  useEffect(() => {
    setSelectedItem(category);
  }, [category]);

  return (
    <div>
      <div className="nav-container">
        <nav className="navbar-vendors">
          <ul className="navbar-menu">
            <li
              className={`navbar-item ${
                selectedItem === "all" ? "active" : ""
              }`}
              onClick={() => handleItemClick("all")}
            >
              All purchase orders
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "listing-view" ? "active" : ""
              }`}
              onClick={() => handleItemClick("listing-view")}
            >
              PO Listings View
            </li>
            <li
              className={`navbar-item ${
                selectedItem === "add" ? "active" : ""
              }`}
              onClick={() => handleItemClick("add")}
            >
              Create new purchase order
            </li>
          </ul>
        </nav>
      </div>

      {selectedItem == "all" && <PurchaseOrdersOpen />}
      {selectedItem == "listing-view" && <PurchaseOrdersListingView />}
      {selectedItem == "add" && <PurchaseOrdersAdd />}
    </div>
  );
}

export default PurchaseOrdersHome;
